// extracted by mini-css-extract-plugin
module.exports = {"restartButton":"styles_restartButton__2KbDk","content":"styles_content__2FbyQ","footer":"styles_footer__2gHVw"};